import React from 'react';
import { Route } from 'react-router-dom';

import { AboutYouPage } from './pages/about-you/about-you';
import { AdditionalGoalsPage } from './pages/additional-goals/additional-goals';
import { AnalyzingProfilePage } from './pages/analyzing-profile/analyzing-profile';
import { CuriousMindPage } from './pages/curious-mind/curious-mind';
import { FeelInsecurePage } from './pages/feel-insecure/feel-insecure';
import { HowFamiliarPage } from './pages/how-familiar/how-familiar';
// import {NavigateYourLovePage} from "./pages/info-pages/navigate-your-love/navigate-your-love";
import { NavigateYourLovePageLazy } from './pages/info-pages/navigate-your-love/navigate-your-love.lazy';
import { PerfectMatchPage } from './pages/info-pages/perfect-match/perfect-match';
import { PersonalReadingPage } from './pages/info-pages/personal-reading/personal-reading';
import { RomanticLifePage } from './pages/info-pages/romantic-life/romantic-life';
import { StrongIntuitionPage } from './pages/info-pages/strong-intuition/strong-intuition';
import { LoveEmotionPage } from './pages/love-emotion/love-emotion';
import { LoveLanguagePage } from './pages/love-language/love-language';
import { OptimistPage } from './pages/optimist/optimist';
import { OthersLikeYouPage } from './pages/others-like-you/others-like-you';
import { RelationshipExpectationsPage } from './pages/relationship-expectations/relationship-expectations';
import { RelationshipGoalsPage } from './pages/relationship-goals/relationship-goals';
import { RelationshipStatusPage } from './pages/relationship-status/relationship-status';
import { ResultPage } from './pages/result/result';
import { StartPage } from './pages/start-page/start-page';
import { TendToOverthinkPage } from './pages/tend-to-overthink/tend-to-overthink';
import { YourBirthdatePage } from './pages/your-birthdate/your-birthdate';
import { YourBirthPlacePage } from './pages/your-birthplace/your-birthplace';
import { YourBirthTimePage } from './pages/your-birthtime/your-birthtime';
import { ZodiacPage } from './pages/zodiac/zodiac';

const routes = [
  <Route key={0} index element={<StartPage />} />,
  <Route key={1} path="how-familiar" element={<HowFamiliarPage />} />,
  <Route key={2} path="relationship-status" element={<RelationshipStatusPage />} />,
  <Route key={3} path="relationship-goals" element={<RelationshipGoalsPage />} />,
  <Route key={4} path="relationship-expectations" element={<RelationshipExpectationsPage />} />,
  <Route key={5} path="love-emotion" element={<LoveEmotionPage />} />,
  <Route key={6} path="love-language" element={<LoveLanguagePage />} />,
  <Route key={7} path="tend-to-overthink" element={<TendToOverthinkPage />} />,
  <Route key={8} path="additional-goals" element={<AdditionalGoalsPage />} />,
  <Route key={9} path="feel-insecure" element={<FeelInsecurePage />} />,
  <Route key={10} path="others-like-you" element={<OthersLikeYouPage />} />,
  <Route key={11} path="curious-mind" element={<CuriousMindPage />} />,
  <Route key={11} path="optimist" element={<OptimistPage />} />,
  <Route key={12} path="about-you" element={<AboutYouPage />} />,
  <Route key={13} path="navigate-your-love" element={<NavigateYourLovePageLazy />} />,
  <Route key={14} path="personal-reading" element={<PersonalReadingPage />} />,
  <Route key={15} path="perfect-match" element={<PerfectMatchPage />} />,
  <Route key={16} path="your-birthdate" element={<YourBirthdatePage />} />,
  <Route key={17} path="your-birthtime" element={<YourBirthTimePage />} />,
  <Route key={18} path="your-birthplace" element={<YourBirthPlacePage />} />,
  <Route key={19} path="romantic-life" element={<RomanticLifePage />} />,
  <Route key={20} path="strong-intuition" element={<StrongIntuitionPage />} />,
  <Route key={21} path="analyzing-profile" element={<AnalyzingProfilePage />} />,
  <Route key={22} path="result" element={<ResultPage />} />,
  <Route key={23} path="zodiac" element={<ZodiacPage />} />,
];

export { routes };
